import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import useLocale from "../../hooks/useLocale";

const YearSelect = ({ year, handleChange = () => {}, ...props }) => {
  const { t } = useLocale();
  const [yearsArray, setYearsArray] = useState([]);

  useEffect(() => {
    const yearsUntilToday = dayjs().diff(dayjs("2000-01-01"), "year");
    setYearsArray([...Array(yearsUntilToday + 1).keys()]);
  }, []);

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="year-select">{t("Year")}</InputLabel>
        <Select
          labelId="year-select"
          id="year-select"
          value={year}
          label={t("Year")}
          onChange={handleChange}
          {...props}
        >
          {yearsArray?.map((item, i) => (
            <MenuItem key={i} value={item + 2000}>
              {item + 2000}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default YearSelect;
